// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue'
import { firestore } from 'firebase'
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators'
import { firestoreAction } from 'vuexfire'
import { db } from '../../firebase/init'
import { InfoBoardType } from '../../types'
import store from '..'


@Module({ name: 'infoBoards', store, dynamic: true })
export default class InfoBoards extends VuexModule {
  boardData:InfoBoardType[] = []

  groupData:InfoBoardType[] = []

  bound = false

  @Mutation
  setBound(bind:boolean = true) {
    this.bound = bind
  }

  get allBoards() {
    if (this.boardData && this.boardData.length > 0) {
      return this.boardData
    } return []
  }

  @Action
  bindInfoBoards() {
    const locationBoards = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('boardData', db.collection('infoBoards').where('location', 'in', [store.getters.location, store.getters.group]))) as Function
    return Promise.all([locationBoards(this.context)])
  }
}

// // ,
// const locationBoards = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('data', db.collection('infoBoards').where('location', '==', store.getters.location))) as Function
// const groupBoards = firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef('groupData', db.collection('infoBoards').where('group', '==', store.getters.group))) as Function
